import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityMetricsCard = ({ title, value, change, changeType, icon, description }) => {
  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 security-shadow-card">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center space-x-3 mb-2">
            <div className="p-2 bg-primary/10 rounded-lg">
              <Icon name={icon} size={20} className="text-primary" />
            </div>
            <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
          </div>
          
          <div className="space-y-2">
            <p className="text-2xl font-bold text-foreground">{value}</p>
            
            {change && (
              <div className="flex items-center space-x-1">
                <Icon 
                  name={getChangeIcon()} 
                  size={16} 
                  className={getChangeColor()}
                />
                <span className={`text-sm font-medium ${getChangeColor()}`}>
                  {change}
                </span>
                <span className="text-sm text-muted-foreground">vs last month</span>
              </div>
            )}
            
            {description && (
              <p className="text-xs text-muted-foreground">{description}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityMetricsCard;